import { generateUUIDv4 } from "./index";

export const hashByKey = <T>(
  items: T[],
  keyGetter?: (item: T) => string | null | undefined
): Record<string, T> => {
  const hash: Record<string, T> = {};
  if (!items || items.length === 0) return hash;

  for (const item of items) {
    const key = keyGetter ? keyGetter(item) : (item["id"] as string);
    if (key !== null && key !== undefined) {
      hash[key] = item;
    } else {
      hash[generateUUIDv4()] = item;
    }
  }
  return hash;
};

export const hashGroupByKey = <T>(
  items: T[],
  keyGetter?: (item: T) => string | undefined | null
): Record<string, T[]> => {
  const hash: Record<string, T[]> = {};
  if (!items || items.length === 0) return hash;

  for (const item of items) {
    const key = keyGetter ? keyGetter(item) : (item["id"] as string);
    if (key !== null && key !== undefined) {
      if (hash[key]) {
        hash[key].push(item);
      } else {
        hash[key] = [item];
      }
    }
  }
  return hash;
};
